import { MODAL_PARAM } from '../consts';
import openModal from './openModal';

export const VPN_DETECTED_MODAL = 'vpn-detected';

export function openVpnDetectedModal(): void {
  const currentModal = new URLSearchParams(window.location.search).get(MODAL_PARAM);

  if (currentModal === VPN_DETECTED_MODAL) {
    return;
  }

  // Replace instead of push: a pushed entry lets browser Back drop the modal
  // while staying on the same page.
  openModal(VPN_DETECTED_MODAL, undefined, { history: 'replace' });
}
